import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  expiredRevisionsController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    'revisionService',
    'dashboardService',
    '$uibModal',
    '$filter',
    '$state',
    'EXT_ICONS',
    '$sce',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      revisionService,
      dashboardService,
      uibModal,
      $filter,
      $state,
      EXT_ICONS,
      $sce
    ) {
      'use strict';

      function loadMore() {
        if ($scope.limitValue + 50 > $scope.totalItem) {
          $scope.limitValue = $scope.totalItem;
        } else {
          $scope.limitValue += 50;
        }
        if ($scope.limitValue >= $scope.totalItem) {
          $scope.activeButton = false;
          $scope.limit = $scope.limitValue;
          return;
        }
      }

      function sortOperation(a, b, column) {
        var res = 0;

        switch (column.type) {
          case 'text':
            res = sortText(a, b, column);
            break;
          case 'number':
            res = sortNumber(a, b, column);
            break;
          case 'date':
            res = sortDate(a, b, column);
            break;
        }
        if (column.sorted === 'desc') return res * -1;

        return res;
      }

      function sortText(a, b, column) {
        if (column.sortExpression !== undefined) {
          var sort1 = $filter('reflect')(a, column.sortExpression);
          var sort2 = $filter('reflect')(b, column.sortExpression);

          if (sort1 === undefined) sort1 = '';
          if (sort2 === undefined) sort2 = '';
          return sort1.toString().localeCompare(sort2);
        } else {
          var value1 = $filter('reflect')(a, column.expression);
          var value2 = $filter('reflect')(b, column.expression);

          if (value1 === undefined) value1 = '';
          if (value2 === undefined) value2 = '';
          return value1.toString().localeCompare(value2);
        }
      }

      function sortNumber(a, b, column) {
        return column.sortExpression !== undefined
          ? $filter('reflect')(a, column.sortExpression) -
              $filter('reflect')(b, column.sortExpression)
          : $filter('reflect')(a, column.expression) -
              $filter('reflect')(b, column.expression);
      }

      function sortDate(a, b, column) {
        var firstDate, secDate;

        if (column.sortExpression !== undefined) {
          firstDate = $filter('reflect')(a, column.sortExpression);
          secDate = $filter('reflect')(b, column.sortExpression);
        } else {
          firstDate = $filter('reflect')(a, column.expression);
          secDate = $filter('reflect')(b, column.expression);
        }
        var firstSplit = firstDate.split('/');
        var secSplit = secDate.split('/');
        firstDate = Date.parse(
          firstSplit[2] + '-' + firstSplit[1] + '-' + firstSplit[0]
        );
        secDate = Date.parse(
          secSplit[2] + '-' + secSplit[1] + '-' + secSplit[0]
        );
        if (firstDate > secDate) return 1;
        if (firstDate < secDate) return -1;
      }

      function limitView() {
        return $scope.expiredDocuments.length < $scope.limitValue
          ? $scope.expiredDocuments.length
          : $scope.limitValue;
      }

      function finalLoadMore() {
        loadMore();
      }

      function validateBetweenDates() {
        if (
          $scope.newForm.startDate.$modelValue >
          $scope.newForm.endDate.$modelValue
        ) {
          swal.fire({
            title: $filter('translate')('AN ERROR OCCURRED'),
            text: $filter('translate')('VALIDATE BETWEEN DATES'),
            icon: 'error',
            showConfirmButton: false,
            showCancelButton: false,
            timer: 3000,
          });

          return false;
        }

        return true;
      }

      function qtdSelected() {
        if ($scope.expiredDocuments.length > 0) {
          $scope.qtdSel = true;
          return $scope.qtdSel;
        } else {
          $scope.qtdSel = false;
          return $scope.qtdSel;
        }
      }

      function selectedDocumentType(value) {
        if (arguments.length === 0) return $scope.documentType;
        $scope.value = '';
        $scope.documentType = value;
      }

      function advancedSearchEvent() {
        if (!$scope.advancedSearch) {
          $scope.allExpired.isChecked = false;
          $scope.allExpiring.isChecked = false;
        }
      }

      function selectedUser(value) {
        if (arguments.length === 0) return $scope.user;
        $scope.value = '';
        $scope.user = value;
      }

      function getStartDate() {
        var startAt;

        if ($scope.allExpiring.isChecked) startAt = $scope.formatedDateNow();
        else if ($scope.allExpired.isChecked) startAt = null;
        else {
          try {
            startAt = $scope.newForm.startDate.$viewValue;
          } catch {
            startAt = null;
          }
        }

        return startAt;
      }

      function getEndDate() {
        var endAt;

        if ($scope.allExpired.isChecked) endAt = $scope.formatedDateNow();
        else if ($scope.allExpiring.isChecked) endAt = null;
        else {
          try {
            endAt = $scope.newForm.endDate.$viewValue;
          } catch {
            endAt = null;
          }
        }

        return endAt;
      }

      function search() {
        $scope.filter = '';
        var valid = true;
        var startAt = $scope.getStartDate();
        var endAt = $scope.getEndDate();

        if (startAt && endAt) valid = $scope.validateBetweenDates();

        if (valid) {
          $scope.expiredDocuments = [];

          revisionService
            .getExpiredRevisions(
              $scope.documentType,
              startAt,
              endAt,
              $scope.user
            )
            .then(function (data) {
              data.forEach(function (document) {
                document.Extension = $scope.getIcon(document.Extension);
                document.Description = $scope.formatedDescription(
                  document.Description
                );
                document.Title = $scope.formatedTitle(document.Title);
                document.Date = $scope.formatedDate(document.Date);
                document.Size = $scope.formatedSize(document.Size);
                document.NextRevisionDate = $scope.formatedDate(
                  document.NextRevisionDate
                );
                $scope.expiredDocuments.push(document);
              });

              $scope.totalItem = $scope.expiredDocuments.length;
              if ($scope.expiredDocuments.length === 0) {
                $scope.filter = 0;
              } else {
                $scope.filter = 1;
              }
            });
        }
      }

      function formatedDate(date) {
        if (date === undefined) return '-';
        if (!date.contains('T')) return date;
        var result = new Date(Date.parse(date));
        return result.format('dd/mm/yyyy');
      }

      function formatedDateNow() {
        var date = new Date();
        return date.format('dd/mm/yyyy');
      }

      function reportExport() {
				try {
					var filter = {};
					filter.reportType = 6;

					filter.FilterType = `${$filter('translate')('DOCUMENT TYPE S')}: ${$scope.documentType.Name} \n${$filter('translate')('USER')}: ${$scope.user.Name}`;

					if ($scope.documentType !== null) {
						filter.IdDocumentType = $scope.documentType.Id;
					}

					if ($scope.user !== null) {
						filter.IdUser = $scope.user.Id;
					}

					if ($scope.allExpired.isChecked) {
						filter.EndDate = new Date().toISOString();
						filter.StartDate = null;
					} else if ($scope.allExpiring.isChecked) {
						filter.EndDate = null;
						filter.StartDate = new Date().toISOString();
					} else {
						filter.EndDate =
							$scope.getEndDate() !== null
								? $scope.newForm.endDate.$modelValue.toISOString()
								: $scope.getEndDate();
						filter.StartDate =
							$scope.getStartDate() !== null
								? $scope.newForm.startDate.$modelValue.toISOString()
								: $scope.getStartDate();
					}

					filter.NoDate = true;
					filter.IsExpiryDate = true;
					filter.dateFilterType = 3;

					if (filter.StartDate !== null || filter.EndDate !== null) {
						filter.NoDate = false;
					}

					uibModal.open({
						animation: true,
						templateUrl: '/views/partials/pickReport.html',
						controller: 'pickReportController',
						size: 'md',
						resolve: {
							filters: function () {
								return filter;
							},
							dashboardService: function () {
								return dashboardService;
							},
							saveAsPdf: function () {
								return $scope.saveAsPdf;
							},
							saveAsXls: function () {
								return $scope.tablesToExcel;
							},
						},
					});
				} catch (err) {
					// eslint-disable-next-line no-console
					console.error('Error:', err);
				}
      }

      function saveAsPdf(filters, dashboardService) {
        dashboardService
          .generateExpiredRevisionsReport(filters)
          .then((res) => {
            if (res.size !== 0) {
              var url = URL.createObjectURL(res);
              window.open(url);
              swal.close();
            } else {
              swal.fire({
                title: 'Relatório em branco',
                text: 'Não existem dados para serem exibidos neste relatório com os filtros selecionados.',
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: $filter('translate')('OK'),
              });
            }
          })
          .catch((error) => {
            swal.fire({
              title: error.title,
              text: error.text,
              icon: 'error',
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
          });
      }

      function getIcon(extension) {
        var ext = extension;

        if (ext.toLowerCase().endsWith('p7s')) {
          var splited = ext.split('.');
          ext = splited[0];
        }

        var image =
          '<img src="/assets/images/file_extensions/default.png" ></img>';
        if (ext !== null && EXT_ICONS.indexOf(ext.toLowerCase()) >= 0) {
          var pngAdjust = ext === 'png' ? 'style="padding-bottom:1px"' : '';
          image =
            '<img src="/assets/images/file_extensions/' +
            ext +
            '.png" onerror="this.src=\'/assets/images/file_extensions/default.png\';" width="18px" ' +
            pngAdjust +
            ' ></img>';
        }

        if (this.isSigned) {
          image +=
            '<img class="signed_doc" src="/assets/images/document_status/seal.png" width="10px"></img>';
        }

        if (this.hasLinkedDocuments === true) {
          image +=
            '<img class="linked_doc" src="/assets/images/document_status/linked.png" width="10px"></img>';
        }

        return $sce.trustAsHtml(image); //Show default icon when the extension icon not exists;
      }

      function formatedSize(size) {
        var sizes = ['B', 'KB', 'MB', 'GB'];
        var len = size;
        var order = 0;
        while (len >= 1024 && order + 1 < sizes.length) {
          order++;
          len = len / 1024;
        }

        if (len !== undefined && len !== null) {
          return len.toFixed(2).toString() + ' ' + sizes[order];
        }

        return '0 KB';
      }

      function loadUsers() {
        dashboardService.getUsers().then((data) => {
          $scope.users = data;
          $scope.users.push({ Name: '-- Todos --', Id: null });
          $scope.users.reverse();
        });
      }

      function loadDocumentTypes() {
        dashboardService.getDocumentTypes().then((data) => {
          $scope.documentTypes = data;
          $scope.documentTypes.push({ Name: '-- Todos --', Id: null });
          $scope.documentTypes.reverse();
        });
      }

      function formatedDocumentType(name) {
        return $filter('truncate')(name, 30, '...', true);
      }

      function formatedTitle(title) {
        return $scope.truncateText(title, 40);
      }

      function truncateText(string, targetCharacterLength) {
        //preciso calcular o tamanho que as tags bold estao ocupando para ficar tudo com tamanho padrao
        targetCharacterLength +=
          (string.substr(0, 60).split('<b>').length - 1) * 3;
        targetCharacterLength +=
          (string.substr(0, 60).split('</b>').length - 1) * 3;

        var length = string.length;
        if (length < targetCharacterLength) {
          return string;
        } else {
          var shortenedString = string.slice(0, targetCharacterLength);
          var tempshortenedString = shortenedString.slice(
            0,
            shortenedString.lastIndexOf(' ')
          );

          var lastMarkupBegin = -1;
          var lastMarkupEnds = -1;
          try {
            lastMarkupBegin = tempshortenedString.lastIndexOf('<b>');
            lastMarkupEnds = tempshortenedString.lastIndexOf('<');
          } catch {}
          if (lastMarkupBegin !== -1) {
            // has an opening anchor tag
            if (lastMarkupEnds === -1) {
              // not having an closing tag
              tempshortenedString = tempshortenedString.slice(
                0,
                lastMarkupBegin
              );
              return tempshortenedString + '... ';
            }
          }

          var idx = shortenedString.lastIndexOf('<');
          var endTag = shortenedString.length - 4;
          if (idx >= endTag) {
            //aqui removemos o final da string caso ela tenha a abertura de alguma tag html
            shortenedString = shortenedString.substr(0, idx);
          }
          //se foi diminuido o tamanho da string comparado a original, então vou colocar tres pontos indicando que o titulo tem mais conteudo
          return shortenedString.length >= length - 4
            ? shortenedString
            : shortenedString + '... ';
        }
      }

      function formatedDescription(description) {
        var result = description ? description : '';
        return result;
      }

      function sortColumn(column) {
        if (column.sortable !== true) return;

        column.sorted = column.sorted === 'asc' ? 'desc' : 'asc';

        var sort = function (a, b) {
          return sortOperation(a, b, column);
        };
        $scope.expiredDocuments = $scope.expiredDocuments.sort(sort);

        var unsorted = $scope.columns.filter(function (c) {
          return c.id !== column.id;
        });

        unsorted.forEach(function (c) {
          c.sorted = undefined;
        });
      }

      function load() {
        $scope.loadDocumentTypes();
        $scope.loadUsers();
        $scope.search();
      }

      function run() {
        try {
          $scope.expiredDocuments = [];
          $scope.columns = [];
          $scope.startDate;
          $scope.endDate;
          $scope.advancedSearch = false;
          $scope.allExpired = { isChecked: false };
          $scope.allExpiring = { isChecked: false };
          $scope.documentTypes;
          $scope.documentType = { Name: '-- Todos --', Id: null };
          $scope.users;
          $scope.user = { Name: '-- Todos --', Id: null };
          $scope.limitValue = 50;
          $scope.limit = 50;
          $scope.report = false;

          $scope.tablesToExcel = (function () {
						var uri =
                'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,',
              template =
                '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
              base64 = function (s) {
                return window.btoa(unescape(encodeURIComponent(s)));
              },
              format = function (s, c) {
                return s.replace(/{(\w+)}/g, function (m, p) {
                  return c[p];
                });
              };
            return function (table, filters) {
              var ctx = '';
              var workbookXML = '';

              ctx = {
                created: new Date().getTime(),
                table: document.getElementById(table).innerHTML,
              };
              workbookXML = format(template, ctx);

							let userName = 'Todos';
							if (filters?.FilterType) {
								const match = filters.FilterType.match(/Usuário:\s*(.+)/);
								if (match && match[1]) {
									userName = match[1].trim();
									if (userName === '-- Todos --' || userName === '--Todos--') {
										userName = 'Todos';
									} else {
										userName = userName.replace(/[-]+/g, '').trim();
										if (!userName) userName = 'Todos';
									}
								}
							}

              setTimeout(function () {
                var link = document.createElement('A');
                link.href = uri + base64(workbookXML);
								link.download = `${userName}-DocumentosVencidos.xls`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }, 3000);
            };
          })();

          $scope.limitView = logWrapper(
            limitView,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.finalLoadMore = logWrapper(
            finalLoadMore,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.validateBetweenDates = logWrapper(
            validateBetweenDates,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.qtdSelected = logWrapper(
            qtdSelected,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectedDocumentType = logWrapper(
            selectedDocumentType,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.advancedSearchEvent = logWrapper(
            advancedSearchEvent,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectedUser = logWrapper(
            selectedUser,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getStartDate = logWrapper(
            getStartDate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getEndDate = logWrapper(
            getEndDate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.search = logWrapper(
            search,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedDate = logWrapper(
            formatedDate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedDateNow = logWrapper(
            formatedDateNow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.reportExport = logWrapper(
            reportExport,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.saveAsPdf = logWrapper(
            saveAsPdf,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getIcon = logWrapper(
            getIcon,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedSize = logWrapper(
            formatedSize,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadUsers = logWrapper(
            loadUsers,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadDocumentTypes = logWrapper(
            loadDocumentTypes,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedDocumentType = logWrapper(
            formatedDocumentType,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedTitle = logWrapper(
            formatedTitle,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.truncateText = logWrapper(
            truncateText,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedDescription = logWrapper(
            formatedDescription,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sortColumn = logWrapper(
            sortColumn,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.load = logWrapper(
            load,
            runtimeConstant.isDebugControllersInternals
          );

          $scope.load();
          $rootScope.$broadcast('clearSearchTerm');

          $scope.autologincolumns = ['icon', 'title', 'description'];

          $scope.imageTypes = ['png', 'gif', 'jpeg', 'jpg', 'bmp'];

          $scope.title = '';
          $scope.description = '';
          $scope.searchTerm = '';

          $scope.columnsToExport = [
            {
              id: 'code',
              header: $filter('translate')('COLUMN.CODE'),
              style: {
                'min-width': '40px',
              },
              expression: 'Code',
              sortExpression: 'Code',
              mobileShow: false,
              dataPriority: 3,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'title',
              width: '35%',
              header: $filter('translate')('COLUMN.TITLE'),
              expression: 'Title',
              style: {
                'min-width': '150px',
              },
              sortExpression: 'Title',
              tooltip: 'tooltipTitle()',
              dataPriority: 1,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'author',
              //width: '25%',
              header: $filter('translate')('COLUMN.AUTHOR'),
              expression: 'Author.Name',
              style: {
                'min-width': '80px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 6,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'folder',
              //width: '80',
              header: $filter('translate')('COLUMN.FOLDER'),
              expression: 'Folder.Name',
              sortExpression: 'Folder.Name',
              style: {
                'min-width': '80px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 3,
              sortable: true,
              disabled: true,
              type: 'text',
            },
            {
              id: 'size',
              //width: '110px',
              header: $filter('translate')('COLUMN.SIZE'),
              expression: 'Size',
              style: {
                'min-width': '100px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 6,
              disabled: true,
              sortable: false,
              type: 'number',
            },
            {
              id: 'NextRevisionDate',
              header: $filter('translate')('COLUMN.DUEDATE'),
              expression: 'NextRevisionDate',
              style: {
                'min-width': '100px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 6,
              disabled: false,
              sortable: true,
              type: 'date',
            },
          ];

          $scope.columns = [
            {
              id: 'icon',
              width: '50',
              header: $filter('translate')('COLUMN.ICON'),
              expression: 'Extension',
              style: {
                padding: '10px 10px 10px 26px',
                'text-overflow': 'clip',
                'max-width': '50px',
              },
              hideHeader: true,
              visible: true,
              disabled: false,
              dataPriority: 1,
            },
            {
              id: 'code',
              //width: '75',
              header: $filter('translate')('COLUMN.CODE'),
              style: {
                'min-width': '40px',
              },
              expression: 'Code',
              sortExpression: 'Code',
              mobileShow: false,
              dataPriority: 3,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'title',
              width: '35%',
              header: $filter('translate')('COLUMN.TITLE'),
              expression: 'Title',
              style: {
                'min-width': '150px',
              },
              sortExpression: 'Title',
              tooltip: 'tooltipTitle()',
              dataPriority: 1,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'author',
              //width: '25%',
              header: $filter('translate')('COLUMN.AUTHOR'),
              expression: 'Author.Name',
              style: {
                'min-width': '80px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 6,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'folder',
              //width: '80',
              header: $filter('translate')('COLUMN.FOLDER'),
              expression: 'Folder.Name',
              sortExpression: 'Folder.Name',
              style: {
                'min-width': '80px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 3,
              sortable: true,
              disabled: true,
              type: 'text',
            },
            {
              id: 'size',
              //width: '110px',
              header: $filter('translate')('COLUMN.SIZE'),
              expression: 'Size',
              style: {
                'min-width': '100px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 6,
              disabled: true,
              sortable: false,
              type: 'number',
            },
            {
              id: 'NextRevisionDate',
              header: $filter('translate')('COLUMN.DUEDATE'),
              expression: 'NextRevisionDate',
              style: {
                'min-width': '100px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 6,
              disabled: false,
              sortable: true,
              type: 'date',
            },
          ];

          if ($state.params.id) {
            $scope.idfolder = parseInt($state.params.id);
          }

          $scope.noDocuments = $scope.idfolder
            ? $filter('translate')('NO DOCUMENTS')
            : $filter('translate')('NO FOLDER SELECTED');
          $scope.noDocumentsMessage = $scope.idfolder
            ? $filter('translate')('NO DOCUMENTS MSG')
            : $filter('translate')('NO FOLDER SELECTED MSG');

          $scope.groups = null;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
